import { useEffect, useState } from 'react'
import { Modal, InputNumber, Radio } from 'antd'
import { ContextMenu } from 'Components'
import { useSpreadSheetData } from './SpreadSheetDataProvider'
import { useEditsHelpers } from './EditsHelpersProvider'
import { useHelpers } from './SpreadSheetHelpersProvider'
import { Check, Code, CornerUpLeft, CornerUpRight, MoreHorizontal, Save, Upload, X, XSquare } from 'react-feather'
import WeaverService from 'Services/WeaverService'
import{ getAffectedRows } from './helpers'
import { setCount, setNodeOrder, setRowsToBeDeleted } from './SpreadSheetDataProvider/actions'

iconStyle = { margin: '0px 4px -2px 0', height: 14 }

export default SpreadSheetContextMenu = ({ children }) ->

  [{
    count,
    editHistory,
    edits,
    nodeOrder,
    rowsToBeDeleted,
    selection,
    selectionType,
    undoHistory
  }, dispatch] = useSpreadSheetData()

  { isIdColumnVisible, setIsIdColumnVisible, isModalVisible, setIsModalVisible } = useHelpers()
  { discardChanges, saveChanges } = useEditsHelpers()

  [hasUnsavedChanges, setHasUnsavedChanges] = useState(false)
  [tabKeys, setTabKeys] = useState([])

  [insertRowsModalIsVisible, setInsertRowsModalIsVisible] = useState(false)
  [rowsToInsert, setRowsToInsert] = useState(1)
  [insertionIsAfter, setInsertionIsAfter] = useState(true)

  useEffect( ->
    setHasUnsavedChanges(
      _.values(edits).find((row) ->
        _.values(row).find((cell) -> cell?)?
      ) or _.values(rowsToBeDeleted).find((r) -> r?)
    )
  , [edits, rowsToBeDeleted])

  <>
    <ContextMenu
      actions={[{
        key: 'undo'
        title: 'Undo'
        disabled: editHistory.length is 0
        icon: <CornerUpLeft style={iconStyle} />
        onClick: -> dispatch(performUndo(edits))
      }, {
        key: 'redo'
        title: 'Redo'
        disabled: undoHistory.length is 0
        icon: <CornerUpRight style={iconStyle} />
        onClick: -> dispatch(performRedo(edits))
      }, {
        key: 'delete-rows'
        title: 'Delete selected rows'
        disabled: -> !selection or !WeaverService.userCanEdit()
        onClick: (e) ->
          [start, end] = getAffectedRows(selection, selectionType, nodeOrder.length)
          dispatch(
            setRowsToBeDeleted({
                rowsToBeDeleted...,
                ([start..end].reduce((acc, n) ->
                  { acc..., [n]: true }
                , {}))...
            })
          )
      }, {
        key: 'insert-rows'
        title: 'Insert rows'
        disabled: -> !selection or !WeaverService.userCanEdit()
        onClick: (e) ->
          [start, end] = getAffectedRows(selection, selectionType, nodeOrder.length)
          setInsertRowsModalIsVisible([start, end])
      }, {
        key: 'show-identifiers'
        title: if isIdColumnVisible then 'Hide Identifiers' else 'Show Identifiers'
        onClick: (e) -> setIsIdColumnVisible(!isIdColumnVisible)
      }, {
        key: 'discard-changes'
        title: 'Discard changes'
        disabled: !hasUnsavedChanges
        onClick: discardChanges
      }, {
        key: 'save-changes'
        title: 'Save changes'
        disabled: !hasUnsavedChanges
        onClick: saveChanges
      }]}
    >
      { children }
    </ContextMenu>
    <Modal
      visible={insertRowsModalIsVisible}
      title="Insert rows"
      okText="Insert"
      onOk={ ->
        [start, end] = insertRowsModalIsVisible
        destination = (insertionIsAfter && end + 1) || start
        dispatch(
          setNodeOrder([
            ...nodeOrder.slice(0, destination),
            ...(new Array(rowsToInsert).fill(undefined)),
            ...nodeOrder.slice(destination)
          ])
        )
        dispatch(setCount(count + rowsToInsert))
        setInsertRowsModalIsVisible(false)
      }
      onCancel={ -> setInsertRowsModalIsVisible(false)}
    >
      <div>
        <InputNumber
          defaultValue={rowsToInsert}
          onChange={(val) -> setRowsToInsert(val)}
          style={{ marginRight: 10 }}
        />
        Number of rows to insert
      </div>
      <div style={{ marginTop: 20 }}>
        <Radio.Group
          onChange={(e) ->
            setInsertionIsAfter(e.target.value)
          }
          value={insertionIsAfter}
        >
          <Radio value={false}>Insert before selection</Radio>
          <Radio value={true}>Insert after selection</Radio>
        </Radio.Group>
      </div>
    </Modal>
  </>
